export default "__VITE_ASSET__BfM$Ttcp__"